/*
 * @Author: suyan
 * @Date: 2022-09-26 10:05:11
 * @LastEditTime: 2022-09-26 13:49:53
 * @Description: 送审相关函数
 */
import { getAccount } from './utils';

/**
 * 判断是否为ios送审版本
 */
export function iosExamine() {
    const TWO = 2;
    const survey = navigator.userAgent.match(/(surveyVer)\/(\S*)/)?.[TWO];
    return Number(survey) === 1;
}

/**
 * android 版本内容是否需要隐藏(安卓送审版，mobilehub配置)
 * @return boolean true：需要隐藏；false：不需要隐藏
 */
export function androidGmgTradeHide() {
    let hkUsTrade = '';
    let androidVersion = '';
    let androidPlatform = '';
    return window.$.ajax({
        url: window.gmg_isHideHkUsTrade_url,
    }).then(async res => {
        if (!res.data) {
            return false;
        }
        hkUsTrade = JSON.parse(res.data.conf_content).isHideHkUsTrade;
        androidVersion = JSON.parse(res.data.conf_content).version;
        androidPlatform = JSON.parse(res.data.conf_content).platform;
        return await isHide(hkUsTrade, androidVersion, androidPlatform);
    }).fail(() => {
        return false;
    });
}

/**
 * 是否隐藏
 */
export async function isHide(hkUsTrade, androidVersion, androidPlatform) {
    // 获取系统的真实版本以及系统类型
    const realVersion = window.getAppVersion() || '';
    const realPlatform = window.getInnerVersion() || '';
    // 判断条件 1.androidPlatform为空，两者都生效
    const condition1 = String(androidPlatform) === '' ;
    // 判断条件 2.androidPlatform不为空
    let condition2;
    if (realPlatform.includes('GZ')) {
        condition2 = androidPlatform.trim() === 'GZ';
    } else {
        condition2 = androidPlatform.trim() === 'G';
    }
    // 判定平台以及版本
    if ((condition1 || condition2) && realVersion === androidVersion) {
        if (String(hkUsTrade) === '2') {
            // 全部隐藏
            return true;
        } else if (String(hkUsTrade) === '1') {
            // 未开户用户隐藏
            return !(await openAccount());
        } else {
            return false;
        }
    }
    return false;
}

/**
 * 是否开户
 * @return boolean true开过户 false未开过户
 */
export async function openAccount() {
    try {
        const data = await getAccount();
        return data.accountList?.length > 0;
    } catch (error) {
        return false;
    }
}
